import questionTypeMultipleChoiceAsListTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/multiple_choice_display_as_list_question_template.ejs';
import questionTypeMultipleChoiceOptionsTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/multiple_choice_options_template.ejs';
import questionTypeNoneTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/none_question_type_message_template.ejs';
import questionTypeCalendarDateTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/calendar_date_question_template.ejs';
import questionTypeTimeOptionsTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/time_options_template.ejs';
import questionTypeTimeCalendarTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/time_calendar_question_template.ejs';
import questionTypeMultipleChoiceTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/multiple_choice_question_template.ejs';
import questionTypeTextTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/text_question_template.ejs';
import questionTypeTimeTemplatePrechat from '../../templates/question_types/prechat_rounded_theme/time_question_template.ejs';

import questionTypeTextTemplate from '../../templates/question_types/text_question_template.ejs';
import questionTypeTimeTemplate from '../../templates/question_types/time_question_template.ejs';
import questionTypeMultipleChoiceAsListTemplate from '../../templates/question_types/multiple_choice_display_as_list_question_template.ejs';
import questionTypeMultipleChoiceOptionsTemplate from '../../templates/question_types/multiple_choice_options_template.ejs';
import questionTypeNoneTemplate from '../../templates/question_types/none_question_type_message_template.ejs';
import questionTypeCalendarDateTemplate from '../../templates/question_types/calendar_date_question_template.ejs';
import questionTypeTimeOptionsTemplate from '../../templates/question_types/time_options_template.ejs';
import questionTypeTimeCalendarTemplate from '../../templates/question_types/time_calendar_question_template.ejs';
import questionTypeMultipleChoiceTemplate from '../../templates/question_types/multiple_choice_question_template.ejs';

// import questionTypeTimeCalendarRDPlusThemeTemplate from '../../templates/question_types/RDPlusTheme/time_calendar_question_template.ejs';


import questionTypeCalendarDateRDPlusThemeTemplate from '../../templates/question_types/RDPlusTheme/calendar_date_question_template.ejs';
import questionTypeMultipleChoiceRDPlusThemeTemplate from '../../templates/question_types/RDPlusTheme/multiple_choice_question_template.ejs';
import questionTypeMultipleChoiceOptionsRDPlusThemeTemplate from '../../templates/question_types/RDPlusTheme/multiple_choice_options_template.ejs';
import questionTypeMultipleChoiceRDPlusThemeTemplatePrechat from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/multiple_choice_question_template.ejs';
import questionTypeMultipleChoiceOptionsRDPlusThemeTemplatePrechat from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/multiple_choice_options_template.ejs';
import questionTypeNoneRDPlusThemeTemplatePrechat from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/none_question_type_message_template.ejs';
import questionTypeNoneRDPlusThemeTemplate from '../../templates/question_types/RDPlusTheme/none_question_type_message_template.ejs';
import questionTypeTextRDPlusThemeTemplatePrechat from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/text_question_template.ejs';

import WidgetTypes from '../../core/enums/WidgetTypes';


// import questionTypeMultipleChoiceAsListRDPlusThemeTemplatePrechat from '../../templates/question_types/RDPlusTheme/prechat_rounded_theme/multiple_choice_display_as_list_question_template.ejs';


const ImportQuestypeTemplateFactory = (options) => {
    const isFromPreChat = options.widgetType === WidgetTypes.PreChat;
    const isFromVideoGreet = options.widgetType === WidgetTypes.VideoGreetInvitation;

    const defaultTemplates = {
        questionTypeTextTemplate,
        questionTypeTimeTemplate,
        questionTypeMultipleChoiceAsListTemplate,
        questionTypeMultipleChoiceOptionsTemplate,
        questionTypeNoneTemplate,
        questionTypeCalendarDateTemplate,
        questionTypeTimeOptionsTemplate,
        questionTypeTimeCalendarTemplate,
        questionTypeMultipleChoiceTemplate
    }
    const preChatTemplates = {
        questionTypeTextTemplate: questionTypeTextTemplatePrechat,
        questionTypeTimeTemplate: questionTypeTimeTemplatePrechat,
        questionTypeMultipleChoiceAsListTemplate: questionTypeMultipleChoiceAsListTemplatePrechat,
        questionTypeMultipleChoiceOptionsTemplate: questionTypeMultipleChoiceOptionsTemplatePrechat,
        questionTypeNoneTemplate: questionTypeNoneTemplatePrechat,
        questionTypeCalendarDateTemplate: questionTypeCalendarDateTemplatePrechat,
        questionTypeTimeOptionsTemplate: questionTypeTimeOptionsTemplatePrechat,
        questionTypeTimeCalendarTemplate: questionTypeTimeCalendarTemplatePrechat,
        questionTypeMultipleChoiceTemplate: questionTypeMultipleChoiceTemplatePrechat
    }
    const rdPlusTemplates = {
        ...defaultTemplates,
        questionTypeMultipleChoiceTemplate: questionTypeMultipleChoiceRDPlusThemeTemplate,
        questionTypeMultipleChoiceOptionsTemplate: questionTypeMultipleChoiceOptionsRDPlusThemeTemplate,
        questionTypeCalendarDateTemplate: questionTypeCalendarDateRDPlusThemeTemplate,
        questionTypeNoneTemplate: questionTypeNoneRDPlusThemeTemplate
    }
    const preChatRdPlusTemplates = {
        ...preChatTemplates,
        questionTypeMultipleChoiceTemplate: questionTypeMultipleChoiceRDPlusThemeTemplatePrechat,
        questionTypeMultipleChoiceOptionsTemplate: questionTypeMultipleChoiceOptionsRDPlusThemeTemplatePrechat,
        questionTypeNoneTemplate: questionTypeNoneRDPlusThemeTemplatePrechat,
        questionTypeTextTemplate: questionTypeTextRDPlusThemeTemplatePrechat
    }

    if (isFromPreChat || isFromVideoGreet) {
        if (ApexChat.IsRoundedDynamicPlusTheme) {
            return preChatRdPlusTemplates;
        }
        return preChatTemplates;
    }
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return rdPlusTemplates;
    }

    return defaultTemplates;
};
export default ImportQuestypeTemplateFactory;
